import React, { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import { InputCheckbox, TextareaField } from '../../../../../utils/InputField';
import { ApiPendingInvoiceCancel } from '../../InvoiceOperation';

function InvoiceCancelModal({ data, handleReload }) {
    const { id } = data;
    const { setConfirm, setMessage } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        Id: id || 0,
        UsingInvoiceNumber: false,
        Note: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(false);
        ApiPendingInvoiceCancel(id, formData, setIsError)
            .then(({ title }) => {
                handleReload();
                setLoading(false);
                setConfirm(null);
                setMessage({ type: 'success', text: title });
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-2">
            {/* <p className="text-base font-normal">Are you sure you want to cancel this invoice?</p> */}

            <TextareaField
                name="Note"
                label="Cancel Note"
                required
                placeholder="Write your notes....."
                formData={formData}
                onChange={handleChange}
                className="h-24"
            />
            <InputCheckbox
                label="Use Invoice Number for Future Invoices"
                name="UsingInvoiceNumber"
                formData={formData}
                onChange={(e) =>
                    setFormData((prev) => ({ ...prev, UsingInvoiceNumber: e.target.checked }))
                }
                text="Will you use this number on other invoices?"
                className="mt-2 mb-3"
            />

            {/* <p className="text-error text-xs text-left ">This field is required.</p> */}
            <div className="w-full flex justify-end items-center gap-2">
                <ButtonCancel title="Cancel" onClick={() => setConfirm(null)} />
                <ButtonPrimary
                    title="Confirm Cancel"
                    btnType="submit"
                    loading={loading}
                    className="bg-error"
                />
            </div>
        </form>
    );
}

export default InvoiceCancelModal;
